module.exports = "<p class=\"Rating\">\n  <i class=\"Icon Icon-star\" ng-class=\"{ 'is-highlighted': star <= rating }\" ng-repeat=\"star in ::stars\"></i>\n</p>\n";


//////////////////
// WEBPACK FOOTER
// ./app/src/directives/rating.html
// module id = 493
// module chunks = 24